<app-block-wrapper [_editable]="_editable" [style]="style" *ngIf="formats$ | async as formats">
  <div class="buttons">
    <a
      appButton
      name="select-format"
      location="convert-from-format-list"
      [analyticsExtra]="format.slug"
      height="4"
      spacing="3"
      shape="round"
      size="3"
      weight="bold"
      [hasIcon]="true"
      *ngFor="let format of formats"
      [routerLink]="['/convert', format.slug]"
    >
      <span>{{ format.slug | uppercase }}</span>
      <app-svg src="/assets/icons/arrow-right.svg"></app-svg>
    </a>
  </div>
</app-block-wrapper>
